import { Autocomplete, Box, styled, Typography } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}));

const InfoColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
});

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.95rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '45%',
});

const Label = styled(Typography)(() => ({
  fontWeight: '400',
  fontSize: '0.95rem',
}));

const Value = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.95rem',
});

const StyledBadge = styled(Box)(({ theme }) => ({
  backgroundColor: '#e3e8ec',
  color: theme.palette.text.primary,
  fontSize: '0.85rem',
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(1, 2),
  cursor: 'pointer',
}));

const StyledAutocomplete = styled(Autocomplete)({
  width: '10rem',
  fontSize: '0.875rem',
  '& .MuiAutocomplete-input': {
    height: '6px',
  },
});

export { Container, InfoColumn, StyledLinkSpan, LabelRow, Label, Value, StyledBadge, Field, Row, StyledAutocomplete };
